const toFiniteNumber = (value) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : null;
};

export const getZoneApprovedRequestsCount = (zone) =>
  toFiniteNumber(zone?.number_of_approved_requests) ??
  toFiniteNumber(zone?.number_of_organizers) ??
  toFiniteNumber(zone?.total_staff) ??
  toFiniteNumber(zone?.total_applicants) ??
  0;

export const getZoneMaximumApprovedRequestsCount = (zone) =>
  toFiniteNumber(zone?.maximum_number_of_approved_requests) ??
  toFiniteNumber(zone?.number_of_organizers) ??
  getZoneApprovedRequestsCount(zone);
